import { Navigation } from '@cannect/new-components/atoms'
import { LinkItem } from '@cannect/new-components/molecules'
import { LuUserCircle } from 'react-icons/lu'

type TAccountMenuItemProps = {
  signedUserName?: string
  handleLogout: () => void
  isLogged: boolean
  className?: string
  withSheetClose?: boolean
}

/**
 * Acesso à conta no header (Figma node 4161:24011): ícone 16px + rótulo 12px SemiBold.
 * Visitante vê "Minha conta" e vai para o login; logado vê "Olá, {nome}" com dropdown.
 * "Meus pedidos" aparece nos dois lugares: na linha do header (ver `menuConfig` em
 * `useHeader`) e também aqui no dropdown, ambos só para usuário logado.
 */
export const AccountMenuItem = ({
  signedUserName,
  handleLogout,
  isLogged,
  className,
  withSheetClose
}: TAccountMenuItemProps) => {
  // `!` obrigatório: navigationMenuTriggerStyle traz `lg:text-primary-800` (rampa legada) na base,
  // e a variante responsiva ganha de uma classe de cor sem prefixo no merge do tailwind-variants.
  const triggerClasses = 'flex items-center gap-1 !text-xs font-semibold leading-[1.4] !text-marketplace-800'

  return (
    <Navigation.MenuList className={className}>
      {isLogged ? (
        <Navigation.MenuItem>
          <Navigation.MenuTrigger>
            <div className={triggerClasses}>
              <LuUserCircle className="h-4 w-4 shrink-0" />
              <span className="inline-block max-w-[130px] truncate font-sans">
                {signedUserName ? `Olá, ${signedUserName}` : 'Minha conta'}
              </span>
            </div>
          </Navigation.MenuTrigger>
          <Navigation.MenuContent className="absolute right-0 z-50 gap-4 rounded-lg border border-neutral-100 bg-white p-2 shadow-lg">
            <LinkItem
              withSheetClose={withSheetClose}
              title="Minha conta"
              path="/painel-do-usuario"
              className="!text-xs !text-marketplace-800"
            />
            <LinkItem
              withSheetClose={withSheetClose}
              title="Meus pedidos"
              path="/conta?pagina=pedidos-todos"
              className="!text-xs !text-marketplace-800"
            />
            <LinkItem
              withSheetClose={withSheetClose}
              onClick={handleLogout}
              title="Sair"
              className="!text-xs !text-marketplace-800"
            />
          </Navigation.MenuContent>
        </Navigation.MenuItem>
      ) : (
        <Navigation.MenuItem>
          <LinkItem
            withSheetClose={withSheetClose}
            iconPlacement="left"
            icon={<LuUserCircle className="h-4 w-4 shrink-0" />}
            title="Minha conta"
            path="/login"
            className={`!no-underline ${triggerClasses}`}
          />
        </Navigation.MenuItem>
      )}
    </Navigation.MenuList>
  )
}
